<!-- Шаг фото: запуск системной камеры, проверка снимка и пересъёмка. -->
<template>
  <VehicleInspectionStepLayout
    :title="review ? 'Фото получилось?' : step.name"
    :description="review ? 'Всё видно и не смазано' : step.description"
  >
    <div class="inspection-photo__preview" :class="{ 'inspection-photo__preview--captured': review }">
      <img v-if="previewUrl" :src="previewUrl" alt="Снятый ракурс ТС" />
      <img v-else-if="exampleImageUrl" :src="exampleImageUrl" alt="Образец снимка ТС" />
      <VehicleIllustration v-else :code="illustrationCode" />
    </div>
    <template #actions>
      <template v-if="review">
        <base-primary-button size="large" :disabled="disabled" @click="confirm">Да, дальше</base-primary-button>
        <base-button size="large" :disabled="disabled" @click="retake">Переснять</base-button>
      </template>
      <template v-else>
        <AttachmentPhotoPicker
          label="Сделать фото"
          variant="primary"
          size="large"
          :disabled="disabled"
          @file-selected="selectFile"
        />
        <base-button v-if="!isRequired" size="large" :disabled="disabled" @click="skip">
          Пропустить
        </base-button>
      </template>
    </template>
  </VehicleInspectionStepLayout>
</template>

<script>
import AttachmentPhotoPicker from "@/components/Attachment/PhotoPicker.vue";
import VehicleInspectionStepLayout from "@/components/Vehicle/Inspection/Step/Layout.vue";
import VehicleIllustration from "@/components/Vehicle/Inspection/VehicleIllustration.vue";
import { attachmentPreviewUrl } from "@/utils/fileUtils";
import { buildVehicleInspectionPhotoCompletion } from "@/utils/vehicleInspectionUtils";

export default {
  name: "VehicleInspectionStepPhoto",
  components: { AttachmentPhotoPicker, VehicleIllustration, VehicleInspectionStepLayout },
  props: {
    step: { type: Object, required: true },
    answer: { type: Object, default: null },
    disabled: { type: Boolean, default: false },
  },
  emits: ["complete"],
  data() { return { file: null, previewUrl: "", review: false }; },
  computed: {
    illustrationCode() { return this.step.config?.example_image || this.step.code; },
    exampleImageUrl() { return attachmentPreviewUrl({ url: this.step.config?.example_image_url }); },
    isRequired() { return this.step.config?.required !== false; },
  },
  created() {
    const attachment = this.answer?.attachments?.[0];
    if (attachment) {
      this.previewUrl = attachmentPreviewUrl(attachment);
      this.review = true;
    }
  },
  beforeUnmount() { this.revokePreview(); },
  methods: {
    selectFile(file) {
      this.revokePreview();
      this.file = file;
      this.previewUrl = URL.createObjectURL(file);
      this.review = true;
    },
    confirm() {
      this.$emit("complete", buildVehicleInspectionPhotoCompletion({
        file: this.file,
        attachments: this.answer?.attachments,
      }));
    },
    skip() {
      this.$emit("complete", buildVehicleInspectionPhotoCompletion({
        attachments: this.answer?.attachments,
        skipped: true,
      }));
    },
    retake() {
      this.revokePreview();
      this.file = null;
      this.previewUrl = "";
      this.review = false;
    },
    revokePreview() {
      if (this.previewUrl.startsWith("blob:")) URL.revokeObjectURL(this.previewUrl);
    },
  },
};
</script>

<style scoped>
.inspection-photo__preview {
  flex: 1;
  min-height: 230px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: color-mix(in srgb, var(--color-light) 94%, var(--color-grey));
  overflow: hidden;
}

.inspection-photo__preview--captured {
  background: var(--color-dark);
}

.inspection-photo__preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

</style>
